// Sprint 12+I (04.07.2026) — Fokustyp-Profil-Content für Pionier-Cockpit &
// Quick-Check-Result. Von Dean als produktions-tauglich signiert.
// Updated: Sprint 12+M5.2 (18.07.2026) — Content v1.1.
// Bewusst lokal im Frontend (kein Backend-Content-Endpoint noetig).

export const FOKUSTYP_PROFILES = {
  bee: {
    key: "bee",
    name: "Biene",
    glyph: "🐝",
    tagline: "Klare Schritte, direkte Umsetzung",
    erkennungsmerkmale: [
      "Du willst wissen, was zu tun ist und wie es funktioniert.",
      "Du liest E-Mails mit To-do-Blick: „Was soll ich tun?“",
      "Du fühlst dich unruhig, wenn Dinge unstrukturiert oder unklar bleiben.",
    ],
    staerke: "Wenn du weißt, was zu tun ist, legst du los. Du bringst Dinge in Bewegung und ziehst sie durch. Ohne Kontrolle und Druck.",
    schatten_seite: "Wenn du absolute Klarheit brauchst, bevor du loslegst — und die Umsetzung wartet, bis das Bild vollständig ist.",
  },
  owl: {
    key: "owl",
    name: "Eule",
    glyph: "🦉",
    tagline: "Big Picture, Zahlen, Daten, Fakten",
    erkennungsmerkmale: [
      "Du willst das große Ganze verstehen, bevor du entscheidest.",
      "Du bemerkst Logiklücken und fehlende Argumente sofort.",
      "Du schätzt Klarheit in Bezug auf Kontext, Zahlen und Systeme.",
    ],
    staerke: "Du bringst Tiefe. Wo andere raten, hast du Zahlen, Daten und Fakten - und den roten Faden.",
    schatten_seite: "Wenn du dich zu sehr auf die Sache fokussierst und den Menschen — oder die Menschen — übersiehst.",
  },
  cat: {
    key: "cat",
    name: "Katze",
    glyph: "🐈",
    tagline: "Emotion, Optionen, Freiheit",
    erkennungsmerkmale: [
      "Du sagst, was du denkst - und lässt dich nicht beeindrucken.",
      "Du liebst deine Freiheit und willst dir Optionen offen halten — kein Druck, kein Zwang.",
      "Du bist offen und humorvoll - und oft eine Spur lauter als die anderen.",
    ],
    staerke: "Du bist kreativ, stark und mutig. Du setzt sich durch - mit Humor, aber bestimmt.",
    schatten_seite: "Wenn du impulsiv reagierst, bevor du nachdenkst — offensiv, schnell, mit wenig Filter.",
  },
  dog: {
    key: "dog",
    name: "Hund",
    glyph: "🐕",
    tagline: "Freundlich und fürsorglich",
    erkennungsmerkmale: [
      "Du fragst dich: „Wie stehen wir zueinander?“",
      "Du bewertest Entscheidungen nach ihren Konsequenzen für andere.",
      "Freundlichkeit, Loyalität und Verlässlichkeit sind für dich eine Grundwährung.",
    ],
    staerke: "Du siehst den Menschen. Wo andere verbissen um die Sache kämpfen, denkst an die Konsequenzen für andere.",
    schatten_seite: "Wenn du für alle anderen da bist und dabei manchmal vergisst, Nein zu sagen.",
  },
};
